###
  Плавный скролл к элементу
###

class INTENT.utils.Scroller

  @to: (target, speed = 300, callback = undefined, correct = 0) ->
    offset = $(target).offset().top - correct
    $("html, body").animate({scrollTop: offset}, speed, callback)